export default "__VITE_ASSET__ru$SgHcr__"